import SiafLiteApiRepository from "../../external/siafLiteApi";

class SituacaoCofinsService {
  constructor() {
    this.urlBase = "/fiscal/situacoes-cofins";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll() {
    return new SiafLiteApiRepository(this.urlBaseEvent).get();
  }
}

export default SituacaoCofinsService;
